// 常量定义（GCJ02/BD09转换核心参数）
const x_pi = 3.14159265358979324 * 3000.0 / 180.0;
const pi = 3.1415926535897932384626;
const a = 6378245.0;
const ee = 0.00669342162296594323;

// 将高德地图的GCJ02坐标转换为百度地图的BD09坐标
export const  transformToBd09 = (data: {lng: number, lat: number}) => {
  const { lng, lat } = data;
  const z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_pi);
  const theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_pi);
  const bdLng = z * Math.cos(theta) + 0.0065;
  const bdLat = z * Math.sin(theta) + 0.006;
  return { lng: bdLng, lat: bdLat };
}


// 将百度地图的BD09坐标转换为高德地图的GCJ02坐标
export const  transformToGcj02 = (data: {lng: number, lat: number}) =>{
    const { lng, lat } = data;
    const x = lng - 0.0065;
    const y = lat - 0.006;
    const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
    const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
    const gcjLng = z * Math.cos(theta);
    const gcjLat = z * Math.sin(theta);
    return { lng: gcjLng, lat: gcjLat };
  }